import React from "react";
import { CommonIconProps } from "./types";
import { IconBase } from "./IconBase"; // Import IconBase

export const IconDoc: React.FC<CommonIconProps> = (props) => {
  return (
    <IconBase
      iconStyle="solid"
      {...props}
      pathData={
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.25 14C6.25 13.5858 6.58579 13.25 7 13.25H8C9.51878 13.25 10.75 14.4812 10.75 16V17C10.75 18.5188 9.51878 19.75 8 19.75H7C6.58579 19.75 6.25 19.4142 6.25 19V14ZM7.75 14.75V18.25H8C8.69036 18.25 9.25 17.6904 9.25 17V16C9.25 15.3096 8.69036 14.75 8 14.75H7.75ZM11.75 15C11.75 14.0335 12.5335 13.25 13.5 13.25H14.5C15.4665 13.25 16.25 14.0335 16.25 15V18C16.25 18.9665 15.4665 19.75 14.5 19.75H13.5C12.5335 19.75 11.75 18.9665 11.75 18V15ZM13.5 14.75C13.3619 14.75 13.25 14.8619 13.25 15V18C13.25 18.1381 13.3619 18.25 13.5 18.25H14.5C14.6381 18.25 14.75 18.1381 14.75 18V15C14.75 14.8619 14.6381 14.75 14.5 14.75H13.5ZM17.25 15C17.25 14.0335 18.0335 13.25 19 13.25H20C20.9665 13.25 21.75 14.0335 21.75 15C21.75 15.4142 21.4142 15.75 21 15.75C20.5858 15.75 20.25 15.4142 20.25 15C20.25 14.8619 20.1381 14.75 20 14.75H19C18.8619 14.75 18.75 14.8619 18.75 15V18C18.75 18.1381 18.8619 18.25 19 18.25H20C20.1381 18.25 20.25 18.1381 20.25 18C20.25 17.5858 20.5858 17.25 21 17.25C21.4142 17.25 21.75 17.5858 21.75 18C21.75 18.9665 20.9665 19.75 20 19.75H19C18.0335 19.75 17.25 18.9665 17.25 18V15Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.19144 22.75C3.58211 22.75 2.27678 21.4403 2.27427 19.823L2.25 4.18619C2.24749 2.56532 3.55429 1.25 5.16717 1.25H11.9695C12.2271 1.25 12.4741 1.35268 12.6564 1.53551L19.4645 8.36329C19.6473 8.5466 19.75 8.79546 19.75 9.05498V12H7C5.89543 12 5 12.8954 5 14V19C5 20.1046 5.89543 21 7 21H19.5033C19.0512 22.0306 18.0256 22.75 16.8328 22.75H5.19144ZM17.8034 9.46008L11.5664 3.20508V7.96008C11.5664 8.7885 12.238 9.46008 13.0664 9.46008H17.8034Z"
            fill="currentColor"
          />
        </>
      }
    />
  );
};
